import { ContentCard } from "@msuite/ui/content-card";
import { DataGrid } from "@msuite/ui/data-grid";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Panels } from "@msuite/ui/panels";
import { formatNumber, guardNumber } from "@msuite/utils/numbers";
import { guardString } from "@msuite/utils/strings";
import { OrganizationCard } from "@/components/cards";
import Notes from "@/components/notes";
import { useCalculation } from "@/hooks/use-calculation";
import type { CalculationPanelBaseProps } from "../shared";

export function CalculationGeneral({ calculationId }: CalculationPanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();
	const { calculation, context } = useCalculation(calculationId);

	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<ContentCard
					icon={icon("Info")}
					title={t("general.general")}
				>
					<DataGrid>
						<DataGrid.Row>
							<DataGrid.Label>{t("general.name")}</DataGrid.Label>
							<DataGrid.Value>{guardString(calculation?.name)}</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Row>
							<DataGrid.Label>{t("projects.fields.client")}</DataGrid.Label>
							<DataGrid.Value>
								{guardString(calculation?._serviceCalculationMeta?._client?.name)}
							</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Divider />
						<DataGrid.Row>
							<DataGrid.Label>{t("organization.data.services")}</DataGrid.Label>
							<DataGrid.Value>
								{guardNumber(calculation?._serviceCalculationItems?.length)}
							</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Row>
							<DataGrid.Label>{t("invoices.sum_net")}</DataGrid.Label>
							<DataGrid.Value>{formatNumber(calculation?.total, "currency")}</DataGrid.Value>
						</DataGrid.Row>
						<DataGrid.Row>
							<DataGrid.Label>{t("invoices.sum_gross")}</DataGrid.Label>
							<DataGrid.Value>
								{formatNumber(guardNumber(calculation?.total) * 1.19, "currency")}
							</DataGrid.Value>
						</DataGrid.Row>
					</DataGrid>
				</ContentCard>
				{context?.type === "parsc" && (
					<ContentCard
						title="Parsc"
						icon={icon("Ticket")}
					>
						<DataGrid>
							<DataGrid.Row>
								<DataGrid.Label>{t("partners.partner")}</DataGrid.Label>
								<OrganizationCard
									orgId={context.parscs?.at(0)?._ticketAssignmentReference._crew.orgId}
									render={(org) => (
										<DataGrid.Value className="items-center">{org?.name}</DataGrid.Value>
									)}
								/>
							</DataGrid.Row>
							<DataGrid.Row>
								<DataGrid.Label>{t("general.references")}</DataGrid.Label>
								<DataGrid.Value>{guardNumber(context.parscs.length)}</DataGrid.Value>
							</DataGrid.Row>
						</DataGrid>
					</ContentCard>
				)}
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<Notes
					notesTable="serviceCalculationNotes"
					identifier={calculationId}
					parent={calculation}
				/>
			</Panels.Panel>
		</Panels>
	);
}
